import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';
import { ApiService } from '../../../services/api.service';

declare let bootbox: any;

@Component({
	selector: 'members-detail-page',
	templateUrl: './detail.html',
	styleUrls: ['./detail.css']
})
export class MembersDetailPage extends NmDetailPageClass {
	public header: string;
	public modelName: string = 'member';

	public reloadTable: boolean = false;
	
	
	public form: FormGroup = this.formBuilder.group({
		// basic information
	  //YFSID: [{value: '', disabled: true}],
	  YFSID: [{value: '',disabled: this.action == 'edit'?true:false}],
		LegacyYFSID: [''],
		HongKongIdentityCard: [''],
	  MemberTypeCode: ['',Validators.required],
	  StatusCode: ['',Validators.required],
		Surname: ['',Validators.required],
		GivenName: ['',Validators.required],
		ChineseName: [''],
		Gender: ['', Validators.required],
		DateOfBirth: [''],
		Telephone1: [''],
		Telephone2: [''],
		EmailAddress: [''],
		AddressLine1: [''],
		AddressLine2: [''],
		AddressLine3: [''],
		SubdistrictId: ['',Validators.required],
		educationLevelId: ['',Validators.required],
		SchoolId: ['',Validators.required],
		schoolYear: [''],
		major: [''],
		formClass: [''],
		memberInterests: [''],
		Language: [''],
		has_coordination: [''],
		Remarks: [''],
		early_bird: [''],
		membership_year: [{value: '',disabled: this.action == 'edit'?true:false}],
		volunteer_type_id: [''],
	});

	public memberData;

	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

		let map = {
			create: 'Members <small><i class="ace-icon fa fa-angle-double-right"></i></small> New Member',
			edit: 'Members <small><i class="ace-icon fa fa-angle-double-right"></i></small> Edit Member',
			view: 'Members <small><i class="ace-icon fa fa-angle-double-right"></i></small> View Member',
		};
		this.header = map[this.action];

		// TODO: dummy way to fix missing fields
		if(this.action != 'create') {
			this.form.removeControl('id_document_number');
		}
	}

	public onBeforeSubmit(data) {
		this._form.setForm(this.form);

		data.DateOfBirth = data.DateOfBirth? this.data.datepicker.toString(data.DateOfBirth): '';

		
		 console.log(data);
		 //return false;
		return data;
	}

	public onBeforePatchValue(data: any): any {
		return new Promise(resolve => {
			
			//hkaf
			data.DateOfBirth = data.DateOfBirth? this.data.datepicker.toObject(data.DateOfBirth): '';
			this.memberData = data;
			console.log(this.memberData);
			let interestArr: string[] = [];
			for(let it of data.interest){
				interestArr.push(it.Id as string);
			}
			data.memberInterests = interestArr;
			console.log(data.memberInterests);
			resolve(data);

			// Promise.all([
			// 	data.home_address && data.home_address.region_id? this.data.shared.getRegionHierarchyById(data.home_address.region_id): [],
			// 	data.office_address && data.office_address.region_id? this.data.shared.getRegionHierarchyById(data.office_address.region_id): []
			// ]).then(values => {
			// 	data._home_region_id = values[0].map(v => v.id);
			// 	data._office_region_id = values[1].map(v => v.id);
			// 	console.log(data);

			// 	resolve(data);
			// });
		});
	}

	public onRenew(early_bird: number){
		this.reloadTable = false;
		bootbox.confirm('Are you sure to renew this member?', (ok) => {
				if(ok) {
					try {
						let promise;
						//promise = this.api.sendApiRequest('post', 'member/batchupload', data).toPromise();
						promise = this.data['member'].renew(this.id,{early_bird:early_bird,renew_year:this.renew_year});

						promise
						.then(res => {
							bootbox.alert({
								message: 'Member renewed successfully',
								callback:() => {
									//this.location.back();
									this.router.navigate(['/members/view/'+this.id]);
									this.reloadTable = true;
								}
							});
						})
						.catch(err => {
							
						});
					}
					catch(e) {
						console.error(e);
					}
				}
			});
	}
}


// WEBPACK FOOTER //
// ./src/pages/members/detail/detail.ts